/* eslint-disable no-console */
import axios from 'axios';
import { ga } from './newsletter';

const errorMessages = {
  emptyName: {
    sk: 'Uveďte svoje meno, radi by sme vás spoznali.',
    en: 'Your name is required, we would like to get to know you.',
  },
  emptyEmail: {
    sk: 'Uveďte svoj e-mail, aby sme vám dokázali odpovedať.',
    en: 'Your email is required, so we can write you back.',
  },
  wrongEmail: {
    sk: 'Skontrolujte e-mailovú adresu, jej tvar nevyzerá správne.',
    en: "This email address doesn't look correct.",
  },
  emptyMessage: {
    sk: 'Toto pole je povinné, je to tá najdôležitejšia časť vašej správy.',
    en: "This field is required, actually that's the most important part.",
  },
  serverError: {
    sk:
      "Máme dočasné technické problémy, mrzí nás to.<br/> Skúste svoju správu poslať znova o niekoľko sekúnd.<br/> Ak to stále nepôjde, jednoducho nám napíšte e-mail na <a href='mailto:hello@lbstudio.sk' class='link link-underlined'>hello@lbstudio.sk</a>.",
    en:
      "We are experiencing technical difficulties. Sorry for that.<br/> You can try to submit your message again in a few seconds.<br/> If it doesn't work, you can just send us an email at <a href='mailto:hello@lbstudio.sk' class='link link-underlined'>hello@lbstudio.sk</a>.",
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('#contact-form')) {
    const language = window.location.pathname.startsWith('/sk/') ? 'sk' : 'en';
    const name = document.querySelector('#name');
    const email = document.querySelector('#email');
    const phoneNumber = document.querySelector('#phone-number');
    const company = document.querySelector('#company');
    const message = document.querySelector('#message');
    const checkbox = document.querySelector('#checkbox');
    const submit = document.querySelector('#submit');
    const serverErrorMessage = document.querySelector('#server-error-message');

    const setErrorMessage = (element, text) => {
      document.querySelector(
        `#${element.id ? element.id : element}-message`
      ).innerHTML = text;
    };

    const checkSuccess = element => {
      element.classList.remove('is-error');
      setErrorMessage(element, null);
      return true;
    };

    const checkError = (element, errorMessage) => {
      element.classList.add('is-error');
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

      setErrorMessage(element, errorMessage);

      return false;
    };

    const checkName = () => {
      if (!name.value) {
        return checkError(name, errorMessages.emptyName[language]);
      }

      return checkSuccess(name);
    };

    const checkEmail = () => {
      const emailpat = /^([a-z0-9])+([.a-z0-9_-])*@([a-z0-9])+(\.[a-z0-9_-]+)+$/i;

      if (!email.value) {
        return checkError(email, errorMessages.emptyEmail[language]);
      }

      if (!emailpat.test(email.value)) {
        return checkError(email, errorMessages.wrongEmail[language]);
      }

      return checkSuccess(email);
    };

    const checkMessage = () => {
      if (!message.value) {
        return checkError(message, errorMessages.emptyMessage[language]);
      }

      return checkSuccess(message);
    };

    const sendMessage = () => {
      const fieldsAreValid = checkName() && checkEmail() && checkMessage();

      if (fieldsAreValid) {
        if (checkbox.checked === true) {
          axios({
            method: 'post',
            url: 'https://www.lbstudio.sk/services/newsletter',
            data: JSON.stringify({
              email: email.value,
              source: `lbstudio-${language}`,
              list: language === 'en' ? 'lbstudio_en' : 'lbstudio',
            }),
            crossDomain: true,
            headers: {
              'Content-Type': 'application/json',
            },
          })
            .then(() => {
              ga('send', 'event', 'contact', 'subscribe', 'success', {
                anonymizeIp: true,
              });
            })
            .catch(error => {
              if (error.response) {
                console.error(error.response.data);
              } else if (error.request) {
                console.error(error.request);
              } else {
                console.error(error.message);
              }
              ga('send', 'event', 'contact', 'subscribe', 'error', {
                anonymizeIp: true,
              });
            });
        }

        axios({
          method: 'post',
          url: 'https://www.lbstudio.sk/services/contact',
          data: JSON.stringify({
            language,
            name: name.value,
            email: email.value,
            phoneNumber: phoneNumber.value,
            company: company.value,
            message: message.value,
          }),
          crossDomain: true,
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(() => {
            ga('send', 'event', 'contact', 'send', 'success', {
              anonymizeIp: true,
            });
            window.location = language === 'en' ? '/thank-you' : '/sk/dakujeme';
          })
          .catch(error => {
            if (error.response) {
              console.error(error.response.data);
            } else if (error.request) {
              console.error(error.request);
            }
            console.error(error.message);

            setErrorMessage(
              'server-error',
              errorMessages.serverError[language]
            );

            serverErrorMessage.classList.remove('visually-hidden');

            ga('send', 'event', 'contact', 'send', 'error', {
              anonymizeIp: true,
            });
          });
      }
    };

    submit.addEventListener('click', () => {
      sendMessage();
    });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/lib/contact.js